<template>
  <div
    v-if="data && list"
    class="basic_wrap"
  >
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <!-- <div class="big_tit">{{$t('item.invest')}}</div> -->
      <div class="big_tit">
        {{ data.title }}
      </div>
      <div class="top_right">
        <span @click="$router.push('/order')">
          <van-icon
            name="todo-list-o"
            size="25"
          />
        </span>
        <span
          style="margin-left: 8px;"
          @click="locationsel = true"
        >
          <van-icon
            name="location-o"
            size="25"
          />
        </span>
      </div>
    </div>
    <van-share-sheet
      v-model="locationsel"
      :title="$t('pro.select')"
      :options="list"
      :cancel-text="$t('utils.cancel')"
      @select="onSelect"
    />
    <div class="product">
      <div class="com-termcodetop">
        <section
          class="kjhistory-k3"
          style="background: rgb(255, 255, 255); border-radius: 0px;"
        >
          <b class="mask" />
          <div class="kjInfo-top">
            <div class="kjInfo clearfix dz5-top">
              <div
                v-if="kai"
                class="dzwinningNums"
              >
                <p class="dztermNum">
                  <span>【{{ kai.ino }}】</span><br>
                  {{ $t('pro.orderrs') }}
                </p>
                <div class="dzDiceImg">
                  <div
                    v-if="kai.da!=2"
                    class="text-ellipsis"
                    :class="kai.da==0?'dz-dice-num':'dz-dice-name'"
                  >
                    {{ kai.da==0?$t('pro.da'):$t('pro.xiao') }}
                  </div>
                  <div
                    v-if="kai.dan!=2"
                    class="text-ellipsis"
                    :class="kai.dan==0?'dz-dice-num':'dz-dice-name'"
                  >
                    {{ kai.dan==0?$t('pro.dan'):$t('pro.shuang') }}
                  </div>
                </div>
              </div>
              <div class="dzdeadline">
                <div class="dz5-top-title">
                  <span>【{{ data.qi }}】</span>
                </div>
                <p class="termNum">
                  <van-count-down
                    :time="data.time*1000"
                    format="HH:mm:ss"
                    @finish="finish"
                  />
                </p>
              </div>
            </div>
          </div>
          <div class="historylist historylistMark">
            <dl>
              <dt>
                <span class="termcode">{{ $t('pro.orderno') }}</span>
                <span class="detail">{{ $t('pro.orderrs') }}</span>
                <!-- <span class="detail">
									<span style="color: #5bdaf9;">{{$t('pro.da')}}</span>
									/ <span style="color: #ffcf81;">{{$t('pro.xiao')}}</span>
								</span>
								<span class="detail">
									<span style="color: #5bdaf9;">{{$t('pro.dan')}}</span>
									/ <span style="color: #ffcf81;">{{$t('pro.shuang')}}</span>
								</span> -->
              </dt>
            </dl>
            <dl
              v-if="kais"
              class="lists"
            >
              <dd v-for="(item, index) in kais">
                <span class="termcode">{{ item.ino }}</span>
                <span
                  v-if="item.da!=2"
                  class="detail"
                >
                  <span :style="item.da==0?'color: #5bdaf9':'color: #ffcf81;'">
                    {{ item.da==0?$t('pro.da'):$t('pro.xiao') }}
                  </span>
                </span>
                <span
                  v-if="item.dan!=2"
                  class="detail"
                >
                  <span :style="item.dan==0?'color: #5bdaf9':'color: #ffcf81;'">
                    {{ item.dan==0?$t('pro.dan'):$t('pro.shuang') }}
                  </span>
                </span>
              </dd>
            </dl>
          </div>
        </section>
      </div>
    </div>
		
    <van-overlay
      :show="show1"
      @click="show1 = false"
    >
      <div
        class="wrapper1"
        style="height: 100vh;100vw;"
        @click.stop
      >
        <div class="block">
          <van-circle
            v-model:current-rate="currentRate"
            :stroke-width="60"
            rate="0"
            size="100%"
            :color="gradientColor"
            text="Opening..."
          />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
	import Fetch from "../../utils/fetch";
	import Vue from 'vue';
	import { Progress,Dialog,
	Overlay,
	Circle,
	Toast,CountDown,Stepper,ShareSheet  } from 'vant';
	Vue.use(Progress).use(Overlay).use(Circle).use(Dialog).use(Toast).use(CountDown).use(Stepper).use(ShareSheet);
	export default {
		name: "Buy",
		data() {
			return {
				show1:false,
				currentRate:0,
				gradientColor:{
					'0%': '#ff8f00',
					'100%': '#ee0a24'
				},
				data: null,
				acc:null,
				
				show_tz:false,
				num: 0,
				da:0,
				xiao:0,
				dan:0,
				shuang:0,
				type:0,
				kai:null,
				kais:null,
				imgs:null,
				list:null,
				locationsel: false,
				time:5000000
			};
		},
		created() {
			this.$parent.footer('item', false);
		},
		mounted() {
			this.start();
			// this.accinfo();
		},
		methods: {
			graptime(randomInt){
				this.currentRate += randomInt;
				if(this.currentRate<100){
					setTimeout(() => {
						this.graptime(randomInt);
					}, 1000);
				}else{
					this.show1 = false;
					this.start();
				}
			},
			finish(){
				this.show1 = true;
				var randomInt = Math.floor(Math.random() * 20) + 10;
				this.currentRate = 0;
				this.graptime(randomInt);
			},
			onSelect(option) {
				this.type = option.id;
				this.start();
				this.locationsel = false;
			},
			accinfo() {
				Fetch('/user/info').then((r) => {
					this.acc = r.data;
				});
			},
			maxnum(){
				// this.number= this.data.max;
			},
			start() {
				this.type = this.$router.history.current.params.code;
				Fetch('/index/item_search', {
					name: "",
					cate: 0
				}).then(r => {
					var list = r.data.list;
					var result = [];
					
					for (var i = 0; i < list.length; i ++) {
						var arr = [];
						if(list[i]){
							var it = {
								id:list[i].id,
								name:list[i].jt,
								icon:list[i].img
							};
							arr.push(it);
						}
						i++;
						
						if(list[i]){
							var it = {
								id:list[i].id,
								name:list[i].jt,
								icon:list[i].img
							};
							arr.push(it);
						}
						i++;
						if(list[i]){
							var it = {
								id:list[i].id,
								name:list[i].jt,
								icon:list[i].img
							};
							arr.push(it);
						}
						i++;
						if(list[i]){
							var it = {
								id:list[i].id,
								name:list[i].jt,
								icon:list[i].img
							};
							arr.push(it);
						}
						i++;
						if(list[i]){
							var it = {
								id:list[i].id,
								name:list[i].jt,
								icon:list[i].img
							};
							arr.push(it);
						}
						result.push(arr);
					}
					this.list = result;
				})
				Fetch('/index/item_detail', {
					id: this.type
				}).then(res => {
					this.data = res.data;
					this.vip = res.data.vip;
					this.imgs = res.data.imgs16;
					this.kais = res.data.kais;
					if(this.kais){
						this.kai = this.kais[0];
					}
					
					this.number= res.data.min;
				})
			}
		}
	};
</script>

<style lang="less" scoped>
	/deep/ .van-cell{
		padding: 15px 26px;
	}
	.red_top_bg {
		position: relative;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		z-index: 10;
	}

	.basic_wrap {
		// background: url(../images/shop2/1.jpg) no-repeat top;
		background-size: 100% 100%;
		background-attachment: fixed;
		max-width: 100%;
		overflow: hidden;
		height: 100%;
		display: block;
		min-height: 100vh;
		padding-bottom: 10vh;
		background-color: #0064d3;
	}
.com-termcodetop {
    width: 100%;
    position: relative;
    left: 0;
    top: 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box
}

.com-termcodetop .kjhistory {
    position: relative;
    z-index: 3
}

.com-termcodetop .kjhistory .kjInfo {
    position: relative;
    z-index: 1;
    padding: 8px 5px 8px 0;
    font-size: 12px;
    color: #666;
    text-align: right
}

.com-termcodetop .kjhistory .kjInfo .deadline > span {
    display: inline-block;
    overflow: hidden;
    max-width: 47%;
    text-overflow: ellipsis;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    white-space: nowrap
}

.com-termcodetop .kjhistory .kjInfo .deadline .fc-red-parent {
    max-width: 35%;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end
}

.com-termcodetop .kjhistory .kjInfo .termNum {
    margin: 0 3px;
    font-weight: 700
}

.com-termcodetop .kjhistory .kjInfo .fc-red {
    color: #d83232;
    margin: 0 3px
}

.com-termcodetop .kjhistory .kjInfo .money {
    position: relative;
    float: right;
    font-size: 14px;
    height: 100%;
    color: red;
    padding-left: 30px
}

.com-termcodetop .kjhistory .kjInfo .money:before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    display: inline-block;
    width: 30px;
    height: 100%;
    background: url(/static/images/myWallet_iii.png?v=2474) no-repeat 50%;
    background-size: 20px 20px
}

.com-termcodetop .kjhistory .historylist {
    display: none;
    position: absolute;
    z-index: 1;
    width: 100%;
    max-height: 318px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overflow-x: hidden;
    background: #fff;
    border-bottom: 1px solid #e0e0e0;
    border-radius: 0 0 10px 10px
}

.com-termcodetop .kjhistory .historylist li {
    width: 100%;
    height: 34px;
    line-height: 34px;
    font-size: 0;
    color: #787878;
    overflow: hidden;
    text-align: left
}

.com-termcodetop .kjhistory .historylist .termcode {
    position: relative;
    display: inline-block;
    font-size: 14px;
    padding: 0 1%;
    border-right: 1px solid #ccc
}

.com-termcodetop .kjhistory .historylist .termcode:after {
    content: "";
    display: block;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    border: 1px solid #ccc;
    background-color: #fff;
    position: absolute;
    top: 14px;
    right: -4px
}

.com-termcodetop .kjhistory .historylist .lottResult {
    display: inline-block;
    font-size: 14px;
    padding-left: 2%
}

.com-termcodetop .kjhistory .historylist .lottResult .redball {
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 24px;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    margin-right: 5px;
    background: linear-gradient(45deg, #d60e00, #ff4639)
}

.com-termcodetop .kjhistory .historylist .lottResult .redball:last-child {
    margin-right: 0
}

.com-termcodetop .kjhistory .historylist .lottResult .hkSix_i {
    display: inline-block;
    color: #fff;
    width: 24px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    border-radius: 50%;
    font-style: normal;
    margin-left: 5px
}

.com-termcodetop .kjhistory .historylist .lottResult .hkSix_i:last-child {
    position: relative;
    margin-left: 10px
}

.com-termcodetop .kjhistory .historylist .lottResult .hkSix_i:last-child:before {
    content: "+";
    position: absolute;
    left: -15px;
    top: 0;
    font-size: 18px;
    color: #888
}

.com-termcodetop .kjhistory .historylist .lottResult .bg_1 {
    background: -webkit-gradient(linear, left bottom, left top, from(#eb3349), to(#f45c43));
    background: linear-gradient(0deg, #eb3349, #f45c43)
}

.com-termcodetop .kjhistory .historylist .lottResult .bg_2 {
    background: #625eb1;
    background-image: linear-gradient(-225deg, #22e1ff, #1d8fe1 48%, #625eb1)
}

.com-termcodetop .kjhistory .historylist .lottResult .bg_3 {
    background: #8ddad5;
    background-image: -webkit-gradient(linear, left bottom, left top, from(#11998e), to(#38ef7d));
    background-image: linear-gradient(0deg, #11998e, #38ef7d)
}

.com-termcodetop .kjhistory .historylist .lottResult .pk10_i {
    display: inline-block;
    color: #fff;
    width: 22px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    border-radius: 5px;
    font-style: normal;
    margin-right: 2px
}

.com-termcodetop .kjhistory .historylist .lottResult .pk10_1 {
    background: -webkit-gradient(linear, left bottom, left top, from(#e6d50e), to(#f7e404));
    background: linear-gradient(0deg, #e6d50e, #f7e404)
}

.com-termcodetop .kjhistory .historylist .lottResult .pk10_2 {
    background: -webkit-gradient(linear, left top, left bottom, from(#00c6fb), to(#054fc3));
    background: linear-gradient(180deg, #00c6fb, #054fc3)
}

.com-termcodetop .kjhistory .historylist .lottResult .pk10_3 {
    background: -webkit-gradient(linear, left top, left bottom, from(hsla(0, 0%, 100%, .15)), to(rgba(0, 0, 0, .15))), radial-gradient(at top center, hsla(0, 0%, 100%, .4) 0, rgba(0, 0, 0, .4) 120%) #6d6c6c;
    background: linear-gradient(180deg, hsla(0, 0%, 100%, .15), rgba(0, 0, 0, .15)), radial-gradient(at top center, hsla(0, 0%, 100%, .4) 0, rgba(0, 0, 0, .4) 120%) #6d6c6c;
    background-blend-mode: multiply, multiply
}

.com-termcodetop .kjhistory .historylist .lottResult .pk10_4 {
    background: -webkit-gradient(linear, left bottom, left top, from(#f84500), to(#f9a323));
    background: linear-gradient(0deg, #f84500, #f9a323)
}

.com-termcodetop .kjhistory .historylist .lottResult .pk10_5 {
    background: linear-gradient(-20deg, #00bacd, #8ddad5)
}

.com-termcodetop .kjhistory .historylist .lottResult .pk10_6 {
    background-image: linear-gradient(135deg, #320ec5, #7908ec)
}

.com-termcodetop .kjhistory .historylist .lottResult .pk10_7 {
    background: -webkit-gradient(linear, left bottom, left top, from(#888785), color-stop(#ada8a8), color-stop(#b5b0b0), to(#d8d5d5));
    background: linear-gradient(0deg, #888785, #ada8a8, #b5b0b0, #d8d5d5)
}

.com-termcodetop .kjhistory .historylist .lottResult .pk10_8 {
    background: -webkit-gradient(linear, left bottom, left top, from(#c10505), to(#f34f4f));
    background: linear-gradient(0deg, #c10505, #f34f4f)
}

.com-termcodetop .kjhistory .historylist .lottResult .pk10_9 {
    background: -webkit-gradient(linear, left top, left bottom, from(#a73737), to(#7a2828));
    background: linear-gradient(180deg, #a73737, #7a2828)
}

.com-termcodetop .kjhistory .historylist .lottResult .pk10_10 {
    background: -webkit-gradient(linear, left bottom, left top, from(#0b7103), to(#06f306));
    background: linear-gradient(0deg, #0b7103, #06f306)
}

.com-termcodetop .kjhistory .historylist .lottResult b {
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 12px;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #c41200;
    background-color: #fcfcfc;
    -webkit-box-shadow: 2px 2px 2px rgba(0, 0, 0, .2);
    box-shadow: 2px 2px 2px rgba(0, 0, 0, .2)
}

.com-termcodetop .kjhistory .historylist .winNums-LHC .lottResult {
    font-size: 12px;
    padding-left: 1%
}

.com-termcodetop .kjhistory .historylist .winNums-LHC .lottResult .redball {
    width: 22px;
    height: 22px;
    line-height: 22px;
    margin-right: 2px
}

.com-termcodetop .kjhistory .historylist .winNums-LHC .lottResult b {
    width: 18px;
    height: 18px;
    line-height: 18px;
    font-size: 12px
}

.com-termcodetop .kjhistory .historylist .winNums-YFT li i {
    margin-right: 9px
}

.com-termcodetop .kjhistory-pc00 {
    position: relative;
    width: 100%;
    height: 3.5rem;
    line-height: 3.5rem;
    font-size: 14px;
    color: #333;
    z-index: 4;
    background: #fff;
    -webkit-box-shadow: 0 .1rem .3rem #eee;
    box-shadow: 0 .1rem .3rem #eee
}

.com-termcodetop .kjhistory-pc00 .roomTop {
    width: 100%;
    height: 70px;
    z-index: 20;
    font-size: 14px;
    font-weight: 700;
    display: table;
    line-height: 2rem
}

.com-termcodetop .kjhistory-pc00 .roomTop .balance, .com-termcodetop .kjhistory-pc00 .roomTop .deadline {
    display: table-cell;
    width: 50%;
    height: 100%;
    vertical-align: middle;
    text-align: center
}

.com-termcodetop .kjhistory-pc00 .roomTop .balance span, .com-termcodetop .kjhistory-pc00 .roomTop .deadline span {
    margin: 0 .3rem;
    font-weight: 400
}

.com-termcodetop .kjhistory-pc00 .kjInfo {
    position: relative;
    z-index: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    height: 34px;
    line-height: 34px;
    border-bottom: 1px solid #e0e0e0
}

.com-termcodetop .kjhistory-pc00 .kjInfo .termcode {
    display: inline-block;
    width: 35%;
    padding-left: 1.5%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap
}

.com-termcodetop .kjhistory-pc00 .kjInfo .termcode h3 {
    display: inline;
    font-size: 14px
}

.com-termcodetop .kjhistory-pc00 .kjInfo .lottResult {
    display: inline-block;
    width: 60%;
    padding-left: 3%;
    text-indent: 2px
}

.com-termcodetop .kjhistory-pc00 .showhistory {
    font-size: 12px;
    color: #666;
    margin: 8px 10px 0 0
}

.com-termcodetop .kjhistory-pc00 .historylist {
    display: none;
    position: relative;
    z-index: 1;
    height: 308px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overflow-x: hidden;
    background: #fff;
    border-bottom: 1px solid #e0e0e0
}

.com-termcodetop .kjhistory-pc00 .historylist li {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    height: 34px;
    line-height: 34px;
    font-size: 14px;
    color: #777;
    -webkit-box-pack: start;
    -ms-flex-pack: start;
    justify-content: flex-start
}

.com-termcodetop .kjhistory-pc00 .historylist li .termcode {
    display: inline-block;
    position: relative;
    padding-left: 1.5%;
    padding-right: 1%;
    text-align: left;
    border-right: 1px solid #e0e0e0
}

.com-termcodetop .kjhistory-pc00 .historylist li .termcode:after {
    content: "";
    display: block;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: #d2d2d2;
    position: absolute;
    top: 14px;
    right: -3px
}

.com-termcodetop .kjhistory-pc00 .historylist li .lottResult {
    padding-left: 1.5%;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.com-termcodetop .kjhistory-pc00 .historylist li .lottResult em, .com-termcodetop .kjhistory-pc00 .historylist li .lottResult i {
    position: relative;
    display: inline-block;
    width: 24px;
    height: 24px;
    line-height: 24px;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    background: linear-gradient(45deg, #d60e00, #ff4639);
    margin-right: 12px
}

.com-termcodetop .kjhistory-pc00 .historylist li .lottResult em + i:before, .com-termcodetop .kjhistory-pc00 .historylist li .lottResult i + i:before {
    content: "+";
    position: absolute;
    left: -10px;
    top: 0;
    color: #888
}

.com-termcodetop .kjhistory-pc00 .historylist li .lottResult em {
    margin-right: 0
}

.com-termcodetop .kjhistory-pc00 .historylist li .lottResult em:before {
    content: "=";
    position: absolute;
    left: -12px;
    top: 0;
    color: #888
}

.com-termcodetop .kjhistory-pc00 .historylist li .lottResult .defaultball {
    background: linear-gradient(45deg, #666, #888)
}

.com-termcodetop .kjhistory-pc00 .historylist li .lottResult .redball {
    background: linear-gradient(45deg, #d60e00, #ff4639)
}

.com-termcodetop .kjhistory-pc00 .historylist li .lottResult .blueball {
    background-image: linear-gradient(-225deg, #22e1ff, #1d8fe1 48%, #625eb1)
}

.com-termcodetop .kjhistory-pc00 .historylist li .lottResult .greenball {
    background-image: -webkit-gradient(linear, left bottom, left top, from(#11998e), to(#38ef7d));
    background-image: linear-gradient(0deg, #11998e, #38ef7d)
}

.com-termcodetop .kjhistory-pc00 .historylist li .lottResult span {
    font-size: 12px
}

.com-termcodetop .showhistory {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    height: 20px;
    line-height: 20px;
    background-color: #efefef;
    border-radius: 20px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    max-width: 90px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.com-termcodetop .historydown {
    display: inline-block;
    font-size: 12px;
    margin: 0 0 0 5px;
    -webkit-animation: uptodown-data-v-70fc7ab9 .2s;
    animation: uptodown-data-v-70fc7ab9 .2s
}

.com-termcodetop .historyup {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
    -webkit-animation: downtoup-data-v-70fc7ab9 .2s;
    animation: downtoup-data-v-70fc7ab9 .2s
}

.com-termcodetop .kjhistory-k3 {
    width: 100%;
    color: #fff;
    background-color: #0e7154;
    border-radius: 5px
}

.com-termcodetop .kjhistory-k3 .showhistory {
    color: #666;
    background-color: #fff;
    margin-top: 10px
}

.com-termcodetop .kjhistory-k3 .kjInfo {
    position: relative;
    z-index: 1;
    min-height: 70px;
    padding: 8px 10px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%
}

.com-termcodetop .kjhistory-k3 .kjInfo .deadline, .com-termcodetop .kjhistory-k3 .kjInfo .winningNums {
    float: left;
    width: 50%;
    height: 100%;
    text-align: right;
    -webkit-box-sizing: border-box;
    box-sizing: border-box
}

.com-termcodetop .kjhistory-k3 .kjInfo .deadline .termNum, .com-termcodetop .kjhistory-k3 .kjInfo .winningNums .termNum {
    font-size: 14px;
    text-align: left;
    line-height: 20px
}

.com-termcodetop .kjhistory-k3 .kjInfo .deadline .termNum span, .com-termcodetop .kjhistory-k3 .kjInfo .winningNums .termNum span {
    font-size: 15px;
    color: #ffcf81;
    margin: 0 3px
}

.com-termcodetop .kjhistory-k3 .kjInfo .winningNums {
    border-right: 1px solid #ccc
}

.com-termcodetop .kjhistory-k3 .kjInfo .winningNums .DiceImg {
    height: 24px;
    line-height: 24px;
    font-size: 24px;
    margin-top: 5px;
    text-align: left
}

.com-termcodetop .kjhistory-k3 .kjInfo .winningNums .iconfont {
    color: #78ba9e;
    margin-left: 2px
}

.com-termcodetop .kjhistory-k3 .kjInfo .winningNums .xiala {
    display: inline-block;
    -webkit-transition: all .3s linear;
    transition: all .3s linear;
    vertical-align: middle;
    -webkit-transform-origin: 50% 45%;
    transform-origin: 50% 45%
}

.com-termcodetop .kjhistory-k3 .kjInfo .deadline .termNum {
    text-align: right
}

.com-termcodetop .kjhistory-k3 .Dice, .com-termcodetop .kjhistory-kg-k3 .Dice {
    display: inline-block;
    width: 28px;
    height: 28px;
    background-image: url(/static/images/diceK3.png?v=2474);
    background-size: 200% 600%;
    vertical-align: middle
}

.com-termcodetop .kjhistory-k3 .Dice1, .com-termcodetop .kjhistory-kg-k3 .Dice1 {
    background-position: 0 0
}

.com-termcodetop .kjhistory-k3 .Dice2, .com-termcodetop .kjhistory-kg-k3 .Dice2 {
    background-position: 0 -100%
}

.com-termcodetop .kjhistory-k3 .Dice3, .com-termcodetop .kjhistory-kg-k3 .Dice3 {
    background-position: 0 -200%
}

.com-termcodetop .kjhistory-k3 .Dice4, .com-termcodetop .kjhistory-kg-k3 .Dice4 {
    background-position: 0 -300%
}

.com-termcodetop .kjhistory-k3 .Dice5, .com-termcodetop .kjhistory-kg-k3 .Dice5 {
    background-position: 0 -400%
}

.com-termcodetop .kjhistory-k3 .Dice6, .com-termcodetop .kjhistory-kg-k3 .Dice6 {
    background-position: 0 -500%
}

.com-termcodetop .kjhistory-k3 .rDice0, .com-termcodetop .kjhistory-kg-k3 .rDice0 {
    background-position: -100% 0
}

.com-termcodetop .kjhistory-k3 .rDice1, .com-termcodetop .kjhistory-kg-k3 .rDice1 {
    background-position: -100% -100%
}

.com-termcodetop .kjhistory-k3 .rDice2, .com-termcodetop .kjhistory-kg-k3 .rDice2 {
    background-position: -100% -200%
}

.com-termcodetop .kjhistory-k3 .rDice3, .com-termcodetop .kjhistory-kg-k3 .rDice3 {
    background-position: -100% -300%
}

.com-termcodetop .kjhistory-k3 .historylist, .com-termcodetop .kjhistory-kg-k3 .historylist {
    position: relative;
    width: 100%;
    font-size: 14px;
    text-align: center;
    z-index: 1
}

.com-termcodetop .kjhistory-k3 .historylist dl, .com-termcodetop .kjhistory-kg-k3 .historylist dl {
    width: 100%
}

.com-termcodetop .kjhistory-k3 .historylist dd, .com-termcodetop .kjhistory-k3 .historylist dt, .com-termcodetop .kjhistory-kg-k3 .historylist dd, .com-termcodetop .kjhistory-kg-k3 .historylist dt {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    height: 40px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    overflow: hidden
}

.com-termcodetop .kjhistory-k3 .historylist dd .termcode, .com-termcodetop .kjhistory-k3 .historylist dt .termcode, .com-termcodetop .kjhistory-kg-k3 .historylist dd .termcode, .com-termcodetop .kjhistory-kg-k3 .historylist dt .termcode {
    width: 25%
}

.com-termcodetop .kjhistory-k3 .historylist dd .lottResult, .com-termcodetop .kjhistory-k3 .historylist dt .lottResult, .com-termcodetop .kjhistory-kg-k3 .historylist dd .lottResult, .com-termcodetop .kjhistory-kg-k3 .historylist dt .lottResult {
    display: inline-block;
    font-size: 14px;
    margin: 0 10px
}

.com-termcodetop .kjhistory-k3 .historylist dd .lottResult .openPastDiceImg, .com-termcodetop .kjhistory-k3 .historylist dt .lottResult .openPastDiceImg, .com-termcodetop .kjhistory-kg-k3 .historylist dd .lottResult .openPastDiceImg, .com-termcodetop .kjhistory-kg-k3 .historylist dt .lottResult .openPastDiceImg {
    position: relative;
    z-index: 4
}

.com-termcodetop .kjhistory-k3 .historylist dd .lottResult .openPastDiceImg .Dice, .com-termcodetop .kjhistory-k3 .historylist dt .lottResult .openPastDiceImg .Dice, .com-termcodetop .kjhistory-kg-k3 .historylist dd .lottResult .openPastDiceImg .Dice, .com-termcodetop .kjhistory-kg-k3 .historylist dt .lottResult .openPastDiceImg .Dice {
    width: 20px;
    height: 20px
}

.com-termcodetop .kjhistory-k3 .historylist dd .detail, .com-termcodetop .kjhistory-k3 .historylist dt .detail, .com-termcodetop .kjhistory-kg-k3 .historylist dd .detail, .com-termcodetop .kjhistory-kg-k3 .historylist dt .detail {
    display: inline-block;
    font-size: 14px;
    margin-right: 4px
}

.com-termcodetop .kjhistory-k3 .historylist .lists, .com-termcodetop .kjhistory-kg-k3 .historylist .lists {
    
}

.com-termcodetop .mask {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .4);
    z-index: 1
}

.com-termcodetop .on .mask {
    display: block
}

.com-termcodetop .on .xiala {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg)
}

.com-termcodetop .kjhistory-k3 .historylist {
    background-color: #333232d1;
	color: hsla(0, 0%, 100%, 0.8);
	border-top: 1px solid #164630;
	border-radius: 0 0 10px 10px;
	font-weight: bold;
}

.com-termcodetop .kjhistory-k3 .historylist dt {
    border-bottom: 1px solid #447762
}

.com-termcodetop .kjhistory-k3 .historylist dt span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}

.com-termcodetop .kjhistory-k3 .historylist dd .termcode {
    position: relative;
    border-right: 1px solid #ccc
}

.com-termcodetop .kjhistory-k3 .historylist dd .termcode:after {
    content: "";
    display: block;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    border: 1px solid #ccc;
    background-color: #056549;
    position: absolute;
    top: 17px;
    right: -4px
}

.com-termcodetop .kjhistory-kg-k3 .historylist dt {
    border-bottom: 1px solid #e5e5e5;
    color: #787878
}

.com-termcodetop .kjhistory-kg-k3 .historylist dt .termcode {
    border-right: none
}

.com-termcodetop .kjhistory-kg-k3 .historylist dt .termcode:after {
    display: none
}

.com-termcodetop .kjhistory-kg-k3 .historylist dd {
    color: #666
}
	

.product .com-termcodetop {
    background: transparent
}

.product .com-termcodetop div.dz5-top {
    padding: 0
}

.product .kjhistory-k3 {
    background: transparent!important
}

.product .dzdeadline {
    // background: -webkit-gradient(linear,left bottom,left top,from(rgba(229,123,130,.6)),to(rgba(237,87,99,.6)));
    background: #fedd02;
    height: 90px;
    margin: 0;
    padding: 0;
	color: #de7f06;
    text-align: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column
}

.product .dzdeadline .dz5-top-title {
    background: transparent;
    padding: 0;
    font-size: 15px;
    font-weight: 700;
	line-height: 20px;
	color: #de7f06;
}

.product .dzdeadline .termNum {
    font-weight: 500;
    line-height: 40px;
    color: #fff;
    text-align: center;
    font-size: 38px
}

.product .dzdeadline .termNum>span,.product .dzwinningNums {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center
}

.product .dzwinningNums {
    margin: 10px 0;
    height: 60px;
    padding: 0 25px;
    width: auto
}

.product .dztermNum {
    width: 147px;
    height: 67px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background: url(../images/31/sekuai.png) no-repeat 50%;
    background-size: 100% 100%;
    color: #0151a4;
    margin: 0 18px 0 0;
    padding: 5px 16px 5px 10px;
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    overflow: hidden;
    -ms-flex-negative: 0;
    flex-shrink: 0;
	line-height: 23px;
}

.product .dzDiceImg {
    -ms-flex-negative: 0;
    flex-shrink: 0;
    width: 165px
}
.dzDiceImg {
    text-align: center;
    font-weight: 700;
    line-height: 1.5
}

.dzdeadline,.dzDiceImg {
    font-size: 13px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    color: #000
}

.dzdeadline {
    margin-top: 10px;
    float: inherit;
    width: 100%;
    padding-left: 10px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center
}

.dzdeadline>div {
    background-image: url(../images/31/k3dzbg.png);
    background-size: 88% 100%;
    background-position: 50%;
    background-repeat: no-repeat;
    color: #fff;
    padding-right: 10px
}

.product .dzDiceImg>div {
    background: no-repeat 50%;
    background-size: cover;
    border-radius: 9px;
    font-size: 13px;
    color: #0151a4;
    font-weight: 700;
    width: auto;
    margin-right: 7px;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    height: 45px;
    line-height: 45px;
    text-align: center;
    overflow: hidden
}

.product .dzDiceImg .dz-dice-name {
    background-image: url(../images/31/item1.png)
}

.product .dzDiceImg .dz-dice-num {
    background-image: url(../images/31/item2.png)
}



.MethodWrap {
    width: 100%;
    display: table
}

.com-k3selector .MethodWrap .Method {
    display: table-cell;
    vertical-align: middle;
    width: 160px;
    padding: 5px;
    margin: 0 auto;
    height: auto;
    color: #fff;
    -webkit-tap-highlight-color: rgba(255,255,255,0)
}

.com-k3selector .MethodWrap .Method .MethodMsg {
    font-size: 12px;
    padding: 0 20px;
    line-height: 20px;
    word-break: break-all;
    color: #caebda;
    margin-bottom: 10px
}

.com-k3selector .MethodWrap .Method ul {
    width: 100%;
    text-align: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin: 0 auto 0 10px
}

.com-k3selector .MethodWrap .Method ul li {
    vertical-align: top;
    display: inline-block;
    text-align: center;
    border: 1px solid hsla(0,0%,100%,.3);
    color: #caebda;
    border-radius: 5px
}

.com-k3selector .MethodWrap .Method ul .checked {
    color: #ffcf81;
    border-color: #ffcf81;
    word-break: break-all
}

.com-k3selector .MethodWrap .Method.method_themeGY ul li {
    overflow: unset;
    border: none
}

.com-k3selector .MethodWrap .Method.method_themeGY ul li span {
    display: block;
    width: 100%;
    height: 45px;
    line-height: 45px;
    font-weight: 700;
    font-size: 15px;
    border: 1px solid #d0d0d0;
    color: #6a6a6a;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 5px;
    -webkit-box-shadow: 0 0 20px 5px #e2e2e2;
    box-shadow: 0 0 20px 5px #e2e2e2
}

.com-k3selector .MethodWrap .Method.method_themeGY ul li p {
    margin-top: 10px;
    color: #6a6a6a
}

.com-k3selector .MethodWrap .Method.method_themeGY ul li.checked span {
    color: #ffcf81;
    border-color: #ffcf81
}

.com-k3selector .MethodWrap .Method0 li {
    width: 21%;
    padding: 10px 0;
    overflow: hidden;
    margin: 5px;
    font-size: 24px;
    line-height: 32px
}

.com-k3selector .MethodWrap .Method0 li p {
    font-size: 12px;
    line-height: 12px
}

.com-k3selector .MethodWrap .Method1 ul,.com-k3selector .MethodWrap .Method4 ul {
    -ms-flex-pack: distribute;
    justify-content: space-around
}

.com-k3selector .MethodWrap .Method1 ul li,.com-k3selector .MethodWrap .Method4 ul li {
    width: 200px;
    min-height: 36px;
    line-height: 36px;
    font-size: 20px;
    padding: 2px 20px;
    margin: 4px auto
}

.com-k3selector .MethodWrap .Method2 li,.com-k3selector .MethodWrap .Method3 li,.com-k3selector .MethodWrap .Method5 li,.com-k3selector .MethodWrap .Method6 li,.com-k3selector .MethodWrap .Method7 li {
    width: 14%;
    height: 26px;
    font-size: 20px;
    padding: 10px 0;
    margin: 5px 3px
}

.com-k3selector .MethodWrap .Method ul li {
    border: 0;
    padding: 0;
    margin: 0 5px 10px
}

.com-k3selector .MethodWrap .Method ul li img {
    width: 100%;
    height: 100%;
    display: block;
    background: #f1f2f6;
    padding: 5px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box
}

.com-k3selector .MethodWrap .Method ul li .ball-txt {
    height: 40px
}

.com-k3selector .MethodWrap .Method ul li .dz5 {
    height: 36px;
    line-height: 36px;
    border-radius: 5px;
    font-size: 13px;
    background: url(../images/31/item-btn.png) no-repeat 50%;
    background-size: cover;
    color: #0151a4;
    text-align: center
}

.com-k3selector .MethodWrap .Method ul li .dz5.dz5checked {
    background-image: url(../images/31/item-click.png)
}








.dz5K3 {
    background: transparent;
    border: 0;
    height: 125px;
    margin: 10px;
    position: relative;
    padding-bottom: 10px
}

.dz5K3 .dzoperate {
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column
}

.dz5K3 .dz5-heji,.dz5K3 .dzoperate {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex
}

.dz5K3 .dz5-heji {
    height: 54px;
    background: #fce3e0;
    color: #de7f06;
    font-weight: 700;
    font-size: 16px;
    padding: 0 5px;
    border-radius: 8px;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    min-width: 175px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center
}

.dz5K3 .dz5-heji .red {
    color: #0a55a2
}

.dz5K3 .rightbtn {
    height: 49px;
    width: 100%;
    background: url(../images/31/btn.png) no-repeat 50%;
    background-size: cover;
    font-size: 16px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    text-align: center;
    color: #fff;
    border-radius: 5px;
    margin-top: 12px
}


.dzdialog {
    width: 100%;
    height: 100px;
    background: #f7f7f7;
    position: absolute;
    bottom: 45px
}

.dzdialog .themeDZ4_order_tip {
    font-size: 12px;
    padding: 2px 0
}

.dzdialog .top {
    font-size: 16px;
    color: #3d4145;
    padding: 10px 0 5px 20px
}

.dzdialog .bottom {
    height: 50px;
    border-top: 1px solid #d6d6d6;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex
}

.dzdialog .bottom .dzinput {
    margin-top: 7px;
    width: 60px;
    border-top: 1px solid #d1d1d1;
    border-bottom: 1px solid #d1d1d1;
    height: 33px
}

.dzdialog .bottom .dzinput .textinput {
    text-align: center;
    width: 100%;
    line-height: 33px
}

.dzdialog .bottom .jianumber {
    border: 1px solid #d1d1d1;
    width: 33px;
    height: 33px;
    line-height: 30px;
    text-align: center;
    margin-top: 7px
}

.dzdialog .bottom .choosemoney {
    margin-left: 150px;
    margin-top: 10px;
    position: relative
}

.dzdialog .bottom .choosemoney .mr2 {
    width: 70px;
    background: #0a55a2;
    color: #fff;
    text-align: center;
    height: 30px;
    line-height: 30px;
    border-radius: 6px;
    position: relative;
    z-index: 100;
    border: 0;
    margin-top: 2px;
    word-break: keep-all;
    white-space: nowrap
}

.dzdialog .bottom .choosemoney .cmoney {
    background: #e9e8ed;
    border-radius: 8px;
    bottom: 40px;
    position: absolute;
    width: 50px;
    z-index: 101
}

.dzdialog .bottom .choosemoney .cmoney .cmcontent {
    text-align: center;
    color: #222
}

.dzdialog .bottom .choosemoney .cmoney .cmcontent:hover {
    color: #fff;
    background: #f60
}

.dz5dialog {
    position: static;
    padding: 15px;
    background: -webkit-gradient(linear,left bottom,left top,from(#fde8e6),to(#fac6bf));
    background: linear-gradient(0deg,#fde8e6,#fac6bf);
    margin: 0 10px;
    border-radius: 9px;
    width: auto;
}

.dz5dialog .bottom {
    border: 0;
    height: 32px;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center
}

.dz5dialog .bottom .choosemoney {
    margin: 0
}

.dz5dialog .bottom .choosemoney .cmoney {
    width: 100%;
    bottom: 35px
}

.dz5dialog .dz5-row {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 152px;
    height: 30px;
    border-radius: 4px
}

.dz5dialog .dz5-row .jianumber {
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    color: #717171;
    font-size: 20px;
    background: #bfbfbf;
    border-radius: 8px 0 0 8px;
    margin: 0
}

.dz5dialog .dz5-row .jianumber.add {
    background: #de7f06;
    border-radius: 0 8px 8px 0;
    color: #fff
}

.dz5dialog .dz5-row .dzinput {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    height: 28px;
    line-height: 28px;
    margin: 0;
    font-size: 16px;
    text-align: center;
    background: #fffadd;
    border: 1px solid #e0e0e0
}

.dz5dialog .dz5-row .dzinput input {
    width: 100%;
    background: none;
    font-size: 14px;
    text-align: center
}

.dz5dialog .dz5-top {
    margin-top: 8px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between
}

.dz5dialog .dz5-top p {
    color: #de7f06;
    font-weight: 700;
    font-size: 13px
}

.dz5dialog .dz5-top .leftbtn {
    width: 50px;
    height: 18px;
    background: #f4c47e;
    color: #de7f06;
    border-radius: 9px;
    font-size: 12px;
    font-weight: 700;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center
}
/deep/ .van-count-down{
	font-weight: 500;
	line-height: 40px;
	color:#646566;
	text-align: center;
	font-size: 38px;
}
.historylistMark{
	.detail{
		display: inline-block !important;
		width: 35%; 
		font-size: 12px !important; 
		overflow: hidden !important; 
		text-overflow: ellipsis !important; 
		white-space: nowrap !important;
	}
}
.lists{
	dd{
		height: 40px; 
		line-height: 40px;
	}
	.detail{
		display: inline-block; 
		width: 35%; 
		font-size: 12px; 
		overflow: hidden; 
		text-overflow: ellipsis; 
		white-space: nowrap; 
		color: rgb(255, 74, 74);
	}
}
.wrapper1 {
	display: flex;
	align-items: center;
	justify-content: center;
}
.block{
  width: 120px;
  height: 120px;
  color: #fff;
}
/deep/ .van-circle__text{
	color:#fff;
}

/* Scoped presentation for this result/detail view. */
.basic_wrap {
	min-height: 100vh;
	padding-bottom: calc(88px + env(safe-area-inset-bottom));
	background: linear-gradient(160deg, #25100c, #120907 58%, #1d0b0a);
	color: #f5dfbd;
}
.red_top_bg {
	min-height: 54px;
	background: rgba(27, 16, 13, .96);
	border-bottom: 1px solid rgba(185, 135, 59, .36);
}
.red_top_bg .big_tit { color: #edc77e; font-weight: 700; }
.red_top_bg .back_left, .red_top_bg .top_right { color: #e6b669; }
.product { padding: 14px; box-sizing: border-box; }
.product .kjhistory-k3 {
	border: 1px solid rgba(230, 182, 105, .5) !important;
	border-radius: 16px !important;
	background: linear-gradient(145deg, #321710, #180d0a) !important;
	box-shadow: 0 16px 32px rgba(0, 0, 0, .3);
	overflow: hidden;
}
.product .com-termcodetop div.dz5-top { background: transparent; }
.product .dzdeadline, .product .dzwinningNums, .product .dztermNum { color: #f7dfb4; }
.product .dzdeadline .dz5-top-title, .product .dzdeadline .termNum { color: #e6b669; }
.product .dzDiceImg>div {
	border-color: rgba(230, 182, 105, .55);
	background: rgba(79, 20, 14, .7);
	color: #ffe3a9;
}
.historylistMark, .historylistMark .lists { background: #1b100d !important; }
.historylistMark dl { border-bottom-color: rgba(185, 135, 59, .2) !important; }
.historylistMark dt, .historylistMark dd, .historylistMark .termcode, .historylistMark .detail { color: #e8ceb0 !important; }
.historylistMark dt { color: #e6b669 !important; background: rgba(185, 135, 59, .09); }
/deep/ .van-share-sheet { background: #1b100d; color: #f5dfbd; }
/deep/ .van-share-sheet__header { color: #f1ca80; }
/deep/ .van-share-sheet__option-name, /deep/ .van-share-sheet__cancel { color: #ead2ae; }
/deep/ .van-overlay { background-color: rgba(8, 3, 2, .78); }
</style>
